import React, { Component } from "react";
import classes from "./Accordion.module.scss";

export default class Accordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }

  componentDidMount() {
    if (this.props.open) {
      this.setState({ isActive: true });
    }
  }

  render() {
    return (
      <div
        className={classes.AccordionWrapper}
        onClick={() =>
          this.props.adSlick
            ? this.setState({ isActive: !this.state.isActive })
            : null
        }
      >
        {!this.props.adSlick ? (
          <h6
            className={classes.AccordionTitle}
            onClick={() => this.setState({ isActive: !this.state.isActive })}
          >
            {this.props.title}{" "}
            {this.state.isActive ? (
              <span className={classes.AccordionSpan}>&#8722;</span>
            ) : (
              <span className={classes.AccordionSpanUpsideDown}>&#43;</span>
            )}
          </h6>
        ) : (
          <h3 className={classes.AccordionTitleAd}>
            {this.props.title}{" "}
            {this.state.isActive ? (
              <span className={classes.AccordionSpanAd}>&#8722;</span>
            ) : (
              <span className={classes.AccordionSpanUpsideDown}>&#43;</span>
            )}
          </h3>
        )}

        {this.state.isActive && (
          <div className={classes.AccordionDiv}>{this.props.data}</div>
        )}
      </div>
    );
  }
}
